module.exports = __webpack_public_path__ + "static/media/right-align.b436b00c.svg";